import './ConfirmSignup.css'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/logo.svg';
import loaderService from '../../service/loaderService';
import { axiosInstance } from '../../config/axiosConfig';
import { showError, showSuccess } from '../../service/toastService';
import { CONFIRM_SIGNUP } from '../../config/endpoint';

const ConfirmSignup = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const emailFromLocation = state?.email || '';

    const schema = yup.object().shape({
        confirmationCode: yup
            .string()
            .required('OTP is required')
            .matches(/^\d{6}$/, 'OTP must be exactly 6 digits'),
        ...(emailFromLocation
            ? {}
            : {
                email: yup
                    .string()
                    .email('Invalid email format')
                    .required('Email is required'),
            }),
    });

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            email: emailFromLocation,
        },
    });

    const onSubmit = (data) => {
        loaderService.show()
        axiosInstance.post(CONFIRM_SIGNUP, data).then(() => {
            showSuccess("Your email is confirmed. Please try to login.")
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        }).catch((err) => {
            showError(err?.response?.data?.message)
        }).finally(() => {
            loaderService.hide()
        })
    };

    return (
        <div className='confirm-signup'>
            <div className='py-32'>
                <img src={logo} alt="logo" />
            </div>

            <form className='confirm-signup-from' onSubmit={handleSubmit(onSubmit)} noValidate>
                <div>
                    <p className='font-24'>Confirm Your Signup</p>
                    <p className='font-16'>Please enter the 6-digit OTP sent to your email.</p>
                </div>

                {!emailFromLocation && (
                    <div>
                        <div className="input-container" style={{ marginBottom: 16 }}>
                            <label htmlFor="email">Email</label>
                            <input
                                id="email"
                                type="email"
                                {...register('email')}
                                className="input"
                                style={{ width: '100%', padding: '8px', fontSize: '16px', marginTop: '4px' }}
                                autoComplete="email"
                            />

                        </div>
                        {errors.email && (
                            <p className="error-message" style={{ color: 'red', marginTop: 4 }}>
                                {errors.email.message}
                            </p>
                        )}
                    </div>
                )}
                <div>
                    <div className="input-container" style={{ marginBottom: 16 }}>
                        <label htmlFor="otp">OTP Code</label>
                        <input
                            id="otp"
                            type="text"
                            maxLength={6}
                            {...register('confirmationCode')}
                            className="input"
                            style={{ width: '100%', padding: '8px', fontSize: '16px', marginTop: '4px' }}
                            autoComplete="one-time-code"
                        />
                    </div>
                    {errors.confirmationCode && (
                        <p className="error-message" style={{ color: 'red', marginTop: 4 }}>
                            {errors.confirmationCode.message}
                        </p>
                    )}
                </div>

                <button
                    type="submit"
                    disabled={isSubmitting}
                    className="theme-sky-btn"
                    style={{ width: '100%', padding: '10px', fontSize: '16px', marginBottom: '12px' }}
                >
                    Verify OTP
                </button>
            </form>
        </div>
    );
};

export default ConfirmSignup;
